const ESTACION_HARDCODED_YPF = {
  razonSocial: "AONIKEN",
  categoriaIVA: "RESPONSABLE INSCRIPTO",
  claveTributaria: "20-10636711-7",
  fechaInicioActividad: "1993-08-01T00:00:00",
  numeroIIBB: "168130/9",
  domicilio: "RUTA NACIONAL 5 KM 525",
  localidad: "BAHIA BLANCA",
  codigoPostal: "",
  provincia: "LA PAMPA",
  leyendaConsignados1: "Por cuenta y orden de",
  leyendaConsignados2: "YPF SA",
  idEstacion: 3,
  nombre: "ESTACION",
};

const getEstacion = async () => {
  return {
    data: ESTACION_HARDCODED_YPF,
  };
};

const estacion = {
  getEstacion,
};

export default estacion;
